<template>
  <div class="dynamic_key_page">
    <img
      v-if="!fullQR"
      class="logo"
      :src="'/' + logo"
      alt="Academy Attendance"
    >

    <div
      v-if="!fullQR"
      class="text"
    >
      <h2>{{ trans('pptQR.please') }}</h2>
      <h4>
        <slot name="explanation" />
      </h4>
    </div>

    <br>

    <div class="key">
      <slot name="key-extra" />
      <br>
      <vue-qrcode
        v-if="url !== null"
        class="qrcode-view"
        :value="url"
        :scale="scale"
        :margin="0"
        level="H"
      />
      <br>
      <h1>{{ code }}</h1>
    </div>

    <div
      v-if="hasButtons"
      class="buttons change"
    >
      <button
        v-if="!fullQR"
        type="button"
        class="btn btn-default pull-left "
        @click="largerQR"
      >
        {{ trans('key.enlarge_qr_size') }}
      </button>
      <button
        v-else
        type="button"
        class="btn btn-default pull-left "
        @click="smallerQR"
      >
        {{ trans('key.shrink_qr_size') }}
      </button>

      <button
        v-if="!signed"
        type="button"
        class="btn btn-danger pull-right"
        @click="openModal = true"
      >
        {{ trans('key.stop_registration') }}
      </button>

      <button
        v-if="!signed"
        type="button"
        class="btn btn-default pull-right"
        @click="$emit('backToLesson')"
      >
        {{ trans('courses.back_to_lesson') }}
      </button>
    </div>

    <modal
      class="align-left"
      :open="openModal"
      :title="trans('key.stop_registration')"
      backdrop="static"
      @close="openModal = false"
    >
      <p>{{ trans('key.stop_registration_question') }}</p>
      <button
        type="button"
        class="btn btn-danger pull-right"
        @click="$emit('stopRegistration')"
      >
        {{ trans('key.stop_registration') }}
      </button>
      <button
        type="button"
        class="btn btn-cancel pull-right"
        @click="openModal = false"
      >
        {{ trans('core.cancel') }}
      </button>
      <br style="clear:both">
    </modal>

    <br style="clear:both;">
  </div>
</template>

<script>
import Modal from '@/students/student-calendar/components/Modal'
import VueQrcode from 'vue-qrcode/lib/esm'

export default {
  name: 'BaseDynamicKey',

  components: {
    Modal,
    VueQrcode,
  },

  props: {
    url: {
      required: true,
      type: String,
    },
    code: {
      required: true,
      type: String,
    },
    logo: {
      type: String,
      default: 'img/aatt.png',
      required: false,
    },
    hasButtons: {
      type: Boolean,
      default: true,
    },
    signed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data () {
    return {
      openModal: false,
      scale: 8,
      fullQR: false,
    }
  },
  methods: {
    largerQR () {
      this.fullQR = true

      if (window.innerHeight > 992 && window.innerWidth > 992) {
        this.scale = 28
      } else {
        this.scale = 16
      }
    },
    smallerQR () {
      this.fullQR = false
      this.scale = 8
    },
  },
}
</script>

<style scoped>
    .btn-danger {
        margin-right: 20px;
        margin-left: 10px;
    }

    .text {
        padding: 10px 40px;
        max-width: 100%;
    }

    .buttons {
        margin-top: 40px;
    }

    .logo {
        max-height: 100px;
        margin-top: 30px;
    }

    .dynamic_key_page {
        text-align: center;
        background: white;
        margin-top: -40px;
        padding-bottom: 50px;
        overflow-x: hidden;
    }

    .align-left {
        text-align: left;
    }

    .qrcode-view {
        min-height: 300px;
    }

    .change {
      padding-left: 20px;
    }
</style>
